import { render } from "./PostDetails.vue?vue&type=template&id=486acada&scoped=true"
import script from "./PostDetails.vue?vue&type=script&lang=js"
export * from "./PostDetails.vue?vue&type=script&lang=js"

import "./post-details.scss?vue&type=style&index=0&id=486acada&lang=scss&scoped=true"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486acada"]])

export default __exports__